import { AsyncField, Field, useFormContext } from '@oscar/form';
import { DatePicker } from '@oscar/theme';
import { Col, Icon, Input, Row, Select } from '@oscar/theme';
import { DatePickerPopulate, TextField } from 'common/components';
import { FORMAT_DATE } from 'common/constants';
import { APIS } from 'common/constants/endpoints';
import { getDateCorrect } from 'features/insulation/utils';
import { debounce } from 'lodash';
import moment from 'moment';
import React from 'react';
import { StatusInstance } from 'views/pages/create-instrulation/hooks/useStatus';
const { Option } = Select;

export const ReinstatementDetail = ({
  statusRequest: { state, status },
}: {
  statusRequest: StatusInstance;
}) => {
  const [formContext] = useFormContext();

  const disableDate = (current: any) => {
    const startDate = formContext.form?.getFieldValue('startDate');
    const endDate = formContext.form?.getFieldValue('endDate');
    if (current) {
      return (
        current < getDateCorrect(startDate) ||
        current > getDateCorrect(endDate).add(1, 'd')
      );
    }
  };
  return (
    <div className="removal-detail">
      <Row gutter={[20, 20]}>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <p className="label-normal">Work Leader Name</p>
              <Field name={['insulationReinstatementDetail', 'workLeaderName']}>
                <Input maxLength={100} placeholder={`Work Leader Name`} />
              </Field>
            </>
          ) : (
            <Field name={['insulationReinstatementDetail', 'workLeaderName']}>
              <TextField label="Work Leader Name" />
            </Field>
          )}
        </Col>
        <Col span={12}>
          {state === 'EDIT' ? (
            <>
              <p className="label-normal">
                Insulation Reinstatement Completion
              </p>
              <Field name={['insulationReinstatementDetail', 'completionDate']}>
                <DatePickerPopulate
                  inputReadOnly={true}
                  format={FORMAT_DATE.SHORT_MONTH_DATE}
                  // disabledDate={disableDate}
                />
              </Field>
            </>
          ) : (
            <Field name={['insulationReinstatementDetail', 'completionDate']}>
              <TextField
                label="Insulation Reinstatement Completion"
                isDate
                formartDate={FORMAT_DATE.SHORT_MONTH_DATE}
              />
            </Field>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ReinstatementDetail;
